/**
 * Production-safe logger utility
 * Only logs in development mode to prevent information leakage
 */

const isDevelopment = process.env.NODE_ENV === 'development';

const logger = {
  log: (...args) => {
    if (isDevelopment) {
      console.log(...args);
    }
  },
  
  warn: (...args) => {
    if (isDevelopment) {
      console.warn(...args);
    }
  },
  
  error: (...args) => {
    // Errors are logged in all environments but sanitized in production
    if (isDevelopment) {
      console.error(...args);
    } else {
      // In production, log a sanitized version without sensitive data
      console.error('An error occurred');
    }
  },
  
  debug: (...args) => {
    if (isDevelopment) {
      console.debug(...args);
    }
  },
  
  info: (...args) => {
    if (isDevelopment) {
      console.info(...args);
    }
  }
};

export default logger;
